import React, { useEffect } from 'react';
import Hero from '../../components/public/Hero';
import '../../styles/yathartha-yes.css';

// SVG Icons
const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
);

const MailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg>
);

// Icon components for features
const BrainIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"></path><path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"></path><path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"></path><path d="M17.599 6.5a3 3 0 0 0 .399-1.375"></path><path d="M6.002 6.5A3 3 0 0 1 5.603 5.125"></path><path d="M11.8 12a1 1 0 0 0-1.6 0l-.9 1.2a3 3 0 0 0 2.8 5l.1-.1"></path></svg>;

const BriefcaseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="14" x="2" y="7" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>;

const ToolsIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>;

const BuildingIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><path d="M9 22v-4h6v4"></path><path d="M8 6h.01"></path><path d="M16 6h.01"></path><path d="M12 6h.01"></path><path d="M12 10h.01"></path><path d="M12 14h.01"></path><path d="M16 10h.01"></path><path d="M16 14h.01"></path><path d="M8 10h.01"></path><path d="M8 14h.01"></path></svg>;

const ChartIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"></path><path d="m19 9-5 5-4-4-3 3"></path></svg>;

const MapPinIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path><circle cx="12" cy="10" r="3"></circle></svg>;

const YatharthaEnterpriseSystem = () => {
    // Add scroll animation observer
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-on-scroll');
                }
            });
        }, { threshold: 0.1 });

        const elements = document.querySelectorAll('.yes-service-card, .yes-reason-card, .yes-step');
        if (elements.length > 0) {
            elements.forEach(el => {
                el.style.opacity = '0';
                observer.observe(el);
            });
        }

        return () => observer.disconnect();
    }, []);

    const services = [
        {
            num: "01",
            title: "Financial Diagnosis & Business Health Checkup",
            description: "A structured, 30-60 question diagnostic that evaluates your business across seven core areas: revenue, pricing, cash flow, operations, compliance, growth, and team. You complete the questionnaire (takes 5-10 minutes and an online meeting of 15 mins), and we deliver a detailed report showing exactly where your money leaks, why you work too many hours, and what gaps are holding you back.",
            whyUseful: [
                "Reveals hidden cash leakage and profitability gaps",
                "Identifies which products, services, or clients are actually profitable",
                "Highlights compliance risks (GST, PF/ESI, labour laws)",
                "Provides a baseline for system development",
                "Helps you make data-driven decisions, not guesses"
            ],
            whoCanBenefit: [
                "Business owners who feel overworked yet under-profitable",
                "Proprietors with no clear financial visibility",
                "Family-run businesses (30-40 years old) needing modernisation",
                "Anyone planning to expand or open a new branch"
            ]
        },
        {
            num: "02",
            title: "Financial Services",
            description: "A part-time, affordable financial leader who provides strategic financial guidance without the cost of a full-time executive. We help you with financial planning, cash flow management, compliance, and profitability analysis. We work forward-looking – using your financial data to build strategy, model decisions, and drive commercial outcomes.",
            whyUseful: [
                "Cash flow forecasting – 13-week rolling forecast to prevent surprises",
                "Profitability analysis – per product, per service, per client, per branch",
                "Budgeting & cost control – identify and eliminate waste",
                "GST & compliance – ensure input credit is claimed, returns are filed on time",
                "Fundraising support – prepare data rooms, financial models, investor decks",
                "Board & investor reporting – professional dashboards and presentations",
                "Working capital optimisation – manage credit terms, reduce receivables"
            ],
            whoCanBenefit: [
                "Startups and SMEs that have outgrown their current financial capabilities",
                "Businesses with ₹50 lakh to ₹50 crore turnover",
                "Companies planning to raise funds or apply for loans",
                "Owners who want to step back from daily financial management",
                "Manufacturing, trading, construction, healthcare, and service businesses"
            ]
        },
        {
            num: "03",
            title: "Advisory & Strategic Leadership",
            description: "We act as a strategic partner to leadership – connecting financial performance to business strategy. We help you define vision, set priorities, build accountability, and execute growth plans. Our CEO advisory services include strategic planning, organisational design, meeting systems, and leadership coaching.",
            whyUseful: [
                "Strategic planning – annual/quarterly OKRs and KPIs",
                "Organisational design – clear roles, RACI matrices, accountability charts",
                "Meeting systems – daily stand-ups, weekly reviews, monthly strategy sessions",
                "Crisis management – turnaround strategies, cost restructuring",
                "Growth & expansion – market entry, new branch setup, M&A readiness",
                "Board preparation – board decks, governance, advisory board setup",
                "Owner freedom – reduce daily involvement from 8-10 hours to <2 hours"
            ],
            whoCanBenefit: [
                "Business owners who are the bottleneck in their own company",
                "Family businesses transitioning to the next generation",
                "Companies with 20-300 employees needing structure",
                "Owners planning to sell or exit in 3-5 years",
                "Anyone opening a second branch or expanding geographically"
            ]
        },
        {
            num: "04",
            title: "System Development Plan (SDP)",
            description: "A custom, week-by-week roadmap that turns your business from a \"job\" into a system-driven asset. We diagnose your pain points, design tailored solutions, and handhold you through implementation. Unlike generic consultants, we don't just give you a report – we build templates, train your staff, and stay until the system works.",
            whyUseful: [
                "Inventory management – daily stock reconciliation, dead stock liquidation, inter-branch transfers",
                "Financial controls – daily cash reconciliation, branch-wise P&L, GST input tracking",
                "Staff management – role clarity, SOPs, training calendars, incentive systems",
                "Multi-branch operations – centralised reporting, stock transfers, manager delegation",
                "Project tracking – timeline monitoring, cost tracking, delay dashboards",
                "Compliance systems – PF/ESI automation, labour law adherence, NABH readiness",
                "Owner freedom – documented holiday protocols, so the business runs without you"
            ],
            whoCanBenefit: [
                "Manufacturers with project delays and inter-departmental handover errors",
                "Retailers (white goods, agro-equipment) with inventory mismatches",
                "Hospital administrators seeking NABH accreditation",
                "Labour contractors with PF/ESI compliance risks",
                "Railway or infrastructure contractors needing project-wise profitability",
                "Any business with multiple departments or branches"
            ]
        },
        {
            num: "05",
            title: "Staff Training & Delegation Systems",
            description: "A structured training programme designed to make your team independent. We define roles, create SOPs, conduct hands-on training, and build accountability systems so you can delegate confidently.",
            whyUseful: [
                "Role clarity – every employee knows their exact responsibilities",
                "SOP documentation – standard operating procedures for every critical task",
                "Training calendars – 4-week structured training for new and existing staff",
                "Manager development – identify and train a capable person to run daily operations",
                "Backend incentives – reward helpers, drivers, and support staff",
                "Holiday readiness – ensure the business runs for 7+ days without you"
            ],
            whoCanBenefit: [
                "Owners who cannot take a holiday because \"only I know how to do it\"",
                "Businesses with high staff turnover or unclear roles",
                "Companies opening new branches needing trained managers",
                "Family businesses where the next generation needs to be brought up to speed"
            ]
        }
    ];

    const targetIndustries = [
        { industry: "Manufacturing", clients: "Manufacturing Company (₹47 Cr, 275 employees), Sarovar Masala (spices)" },
        { industry: "Retail / Trading", clients: "White goods dealer (30-40 years family business), Ridhima Agro (agri-equipment)" },
        { industry: "Construction & Infrastructure", clients: "Railway contractors, breaker dealers, labour contractors" },
        { industry: "Healthcare", clients: "30-bed hospitals seeking NABH accreditation" },
        { industry: "Hospitality", clients: "Hotel suppliers, catering businesses" },
        { industry: "Professional Services", clients: "Digital marketing agencies, consulting firms" }
    ];

    const reasons = [
        { title: "Strategic & Finance Expertise", desc: "We don't just look at numbers; we look at the whole business.", icon: <BrainIcon /> },
        { title: "Fractional Model", desc: "Affordable, part-time access to senior leadership.", icon: <BriefcaseIcon /> },
        { title: "Hands-on Approach", desc: "We build templates, configure software, and train your team.", icon: <ToolsIcon /> },
        { title: "Industry Experience", desc: "We understand manufacturing, retail, healthcare, construction, and trading.", icon: <BuildingIcon /> },
        { title: "Measurable Outcomes", desc: "We track what we deliver (e.g., on-time project completion, reduced errors, owner freedom).", icon: <ChartIcon /> },
        { title: "Pan-India Reach", desc: "Remote support with occasional in-person visits.", icon: <MapPinIcon /> }
    ];

    return (
        <div className="yes-page">
            <Hero
                title="Yathartha Enterprise System (YES)"
                subtitle="From Chaos to Clarity"
                description="We provide Strategic Operations & Financial services to help business owners build systems, gain financial clarity, and achieve freedom from daily operations."
                backgroundImage="/Philosophy.jpeg"
            />
            
            <section className="yes-intro">
                <div className="container">
                    <div className="yes-intro-card">
                        <p>
                            Our approach combines strategic leadership with financial discipline, delivered through a fractional or project-based model.
                            Whether you are a manufacturer, hospital, construction contractor, or family-run trading business, we help you move from 
                            <strong> chaos to clarity</strong>, from <strong>reactive firefighting to proactive growth</strong>.
                        </p>
                    </div>
                </div>
            </section>

            <section className="yes-services">
                <div className="container" style={{ maxWidth: '1200px' }}>
                    {services.map((service, index) => (
                        <div key={index} className="yes-service-card">
                            <div className="yes-service-header">
                                <span className="yes-service-number">{service.num}</span>
                                <h2 className="yes-service-title">{service.title}</h2>
                            </div>
                            <p className="yes-service-desc">{service.description}</p>
                            
                            <div className="yes-service-grid">
                                <div className="yes-box yes-box-useful">
                                    <h4>Why It Is Useful</h4>
                                    <ul className="yes-list">
                                        {service.whyUseful.map((point, i) => (
                                            <li key={i}>{point}</li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="yes-box yes-box-benefit">
                                    <h4>Who Can Benefit</h4>
                                    <ul className="yes-list">
                                        {service.whoCanBenefit.map((point, i) => (
                                            <li key={i}>{point}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <section className="yes-target">
                <div className="container">
                    <h2 className="yes-section-title">Who Are These Services For?</h2>
                    <p className="yes-section-subtitle">We work with a wide range of businesses across India</p>
                    
                    <div className="yes-table-wrapper">
                        <table className="yes-table">
                            <thead>
                                <tr>
                                    <th>Industry</th>
                                    <th>Typical Clients</th>
                                </tr>
                            </thead>
                            <tbody>
                                {targetIndustries.map((row, index) => (
                                    <tr key={index}>
                                        <td className="yes-table-industry">{row.industry}</td>
                                        <td>{row.clients}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            <section className="yes-reasons">
                <div className="container">
                    <h2 className="yes-section-title">Why Choose Us?</h2>
                    <p className="yes-section-subtitle">The Yathartha Advantage</p>
                    
                    <div className="yes-reasons-grid">
                        {reasons.map((item, index) => (
                            <div key={index} className="yes-reason-card">
                                <div className="yes-reason-icon">
                                    {item.icon}
                                </div>
                                <h4>{item.title}</h4>
                                <p>{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="yes-cta">
                <div className="container">
                    <div className="yes-contact-header">
                        <h3>Get Started Today</h3>
                        <p>Four simple steps to transform your business</p>
                    </div>
                    
                    <div className="yes-steps">
                        {[
                            { title: "Discovery", text: "Book a free discovery call – we'll understand your business and pain points.", icon: <PhoneIcon /> },
                            { title: "Diagnosis", text: "Complete a Financial Diagnosis – get a clear picture of where you stand.", icon: <ChartIcon /> },
                            { title: "Engagement", text: "Choose an engagement model – one-time system design, monthly retainer, or combined package.", icon: <BriefcaseIcon /> },
                            { title: "System Build", text: "Start building systems – we handhold you until the business runs without you.", icon: <ToolsIcon /> }
                        ].map((item, index) => (
                            <div key={index} className="yes-step">
                                <div className="yes-step-num">0{index + 1}</div>
                                <div className="yes-step-icon">{item.icon}</div>
                                <h4 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '0.75rem', fontWeight: 600, position: 'relative', zIndex: 2 }}>{item.title}</h4>
                                <p className="yes-step-text">{item.text}</p>
                            </div>
                        ))}
                    </div>
                    
                    <div className="yes-contact-wrapper">
                        <div className="yes-contact-card">
                            <div className="yes-contact-header" style={{ marginBottom: '2.5rem' }}>
                                <h3>Ready to build a business that works for you, not the other way?</h3>
                                <p>Take the first step towards clarity and freedom.</p>
                            </div>
                            
                            <div className="yes-profile">
                                <div className="yes-avatar-container">
                                    <div className="yes-avatar-pulse"></div>
                                    <div className="yes-avatar">NK</div>
                                </div>
                                <div className="yes-profile-info">
                                    <h4 className="yes-profile-name">Neha Khapare</h4>
                                    <p className="yes-profile-title">Director, CEO</p>
                                    
                                    <div className="yes-profile-contact">
                                        <a href="tel:7038377377" className="yes-contact-link">
                                            <PhoneIcon />
                                            7038377377
                                        </a>
                                        <a href="mailto:connect.yathartha@gmail.com" className="yes-contact-link">
                                            <MailIcon />
                                            connect.yathartha@gmail.com
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default YatharthaEnterpriseSystem;
